// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"2d0beb0c","666":"4fcd65dc","972":"a2e98408"}[chunkId] + ".chunk.css";
};